"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const NavItem = ({ item, dropdownEnabled = true, dropdownAutoClose, collapseEnabled = false, dropdownPlacement, level = 0, }) => {
    let linkArgs = {};
    const isDropdown = item.children &&
        !(Array.isArray(item.children) &&
            item.children.length < 1);
    const isMegaMenu = isDropdown && !Array.isArray(item.children);
    if (item.isActive === true) {
        linkArgs['aria-current'] = 'page';
    }
    if (item.isDisabled === true) {
        linkArgs['aria-disabled'] = 'true';
        linkArgs['tabIndex'] = '-1';
    }
    if (item.target) {
        linkArgs['target'] = item.target;
    }
    const maybeDropdown = (0, react_1.useCallback)((e) => {
        e.stopPropagation(); // this is just to prevent the click from closing the parent dropdown
    }, []);
    if (isDropdown) {
        linkArgs['aria-expanded'] = 'false';
        linkArgs['role'] = 'button';
        if (dropdownEnabled) {
            linkArgs['data-bs-toggle'] = 'dropdown';
            if (!dropdownAutoClose) {
                linkArgs['data-bs-auto-close'] = isMegaMenu
                    ? 'outside'
                    : 'true';
            }
        }
        if (collapseEnabled) {
            linkArgs['data-bs-toggle'] = 'collapse';
        }
        if (level > 0) {
            linkArgs['onClick'] = maybeDropdown;
        }
    }
    return (react_1.default.createElement("li", { className: (0, classnames_1.default)('nav-item', (isDropdown && dropdownEnabled) && [
            isDropdown && 'dropdown',
            level > 0 && 'submenu',
            dropdownPlacement,
        ], isMegaMenu && 'dropdown-mega-menu', ...(item.classNames || [])) },
        react_1.default.createElement("a", Object.assign({ className: (0, classnames_1.default)('nav-link', item.isActive === true && 'active', item.isDisabled === true && 'disabled', dropdownEnabled && isDropdown === true && 'dropdown-toggle', collapseEnabled && isDropdown === true && 'collapse-toggle'), href: item.href }, linkArgs), item.label),
        isDropdown && (react_1.default.createElement("ul", { className: (0, classnames_1.default)(dropdownEnabled && 'dropdown-menu', collapseEnabled && 'collapse', isMegaMenu && 'mega-menu') }, isMegaMenu === true ? (
        // @ts-ignore
        react_1.default.createElement("li", null, item.children)) : (item.children.map((item, childIndex) => react_1.default.createElement(NavItem, { key: childIndex, item: item, dropdownEnabled: dropdownEnabled, dropdownAutoClose: dropdownAutoClose, collapseEnabled: collapseEnabled, dropdownPlacement: dropdownPlacement || 'dropend', level: level + 1 })))))));
};
exports.default = NavItem;
